import { Link } from "react-router-dom";
import { useState } from "react";
import { Moon, Sun } from "@phosphor-icons/react";
import { toggleTheme, isDark } from "@/lib/theme";

const LINKS = [
  { to: "/privacy", label: "Privacy Policy" },
  { to: "/terms", label: "Terms & Conditions" },
  { to: "/cookies", label: "Cookie Policy" },
  { to: "/data-deletion", label: "Data Deletion" },
  { to: "/contact", label: "Contact" },
  { to: "/support", label: "Support" },
];

export default function Footer() {
  const [dark, setDark] = useState(isDark());
  const year = new Date().getFullYear();

  return (
    <footer className="border-t border-border bg-card mt-auto" data-testid="legal-footer">
      <div className="max-w-[1600px] mx-auto px-6 py-6 flex flex-col sm:flex-row items-center justify-between gap-4">
        <nav className="flex flex-wrap gap-x-5 gap-y-2 justify-center sm:justify-start">
          {LINKS.map((l) => (
            <Link
              key={l.to}
              to={l.to}
              data-testid={`footer-link-${l.to.replace("/", "")}`}
              className="text-sm text-muted-foreground hover:text-foreground transition-colors"
            >
              {l.label}
            </Link>
          ))}
        </nav>
        <div className="flex items-center gap-3">
          <span className="text-xs text-muted-foreground font-mono">© {year} GrowthAI</span>
          <button
            type="button"
            onClick={() => setDark(toggleTheme())}
            data-testid="theme-toggle"
            aria-label="Toggle theme"
            className="p-2 rounded-sm text-muted-foreground hover:text-foreground hover:bg-secondary transition-colors"
          >
            {dark ? <Sun size={16} weight="bold" /> : <Moon size={16} weight="bold" />}
          </button>
        </div>
      </div>
    </footer>
  );
}
